import { createAction } from 'redux-actions';

export const OPEN_ALERT_WINDOW = '@onlineOrderManagement-workflow/OPEN_ALERT_WINDOW';
export const openAlertWindow = createAction(OPEN_ALERT_WINDOW);

export const CLOSE_ALERT_WINDOW = '@onlineOrderManagement-workflow/CLOSE_ALERT_WINDOW';
export const closeAlertWindow = createAction(CLOSE_ALERT_WINDOW);
